/* prettier-ignore */

import { Injectable } from '@angular/core'
import { Router, NavigationEnd } from '@angular/router'
import { RestService } from 'src/app/services/rest.service';
import { NavController } from '@ionic/angular'

@Injectable({
  providedIn: 'root'
})

export class NavigationService {
  private history: string[] = []

  constructor(private router: Router, public rest: RestService, public navCtrl: NavController) { }

  public startSaveHistory():void{
    const customRoutePattern = /^\/custom-route\/\d+$/;
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (customRoutePattern.test(event.urlAfterRedirects))
          return;

        const lastUrl = this.history?.[this.history?.length - 1];
        if (lastUrl === event.urlAfterRedirects)
          return;

        // Misma ruta con distintos query params (p.ej. filtros de listados):
        // reemplazar la última entrada en vez de apilar cada cambio de filtro
        if (lastUrl?.split('?')[0] === event.urlAfterRedirects.split('?')[0]) {
          this.history[this.history.length - 1] = event.urlAfterRedirects;
          return;
        }

        this.history.push(event.urlAfterRedirects)
      }
    })
  }

  public resetNavigation(){
    this.history = [];
  }

  public goBack(): void {
    this.history.pop();
    if (this.history.length > 0) {
      const lastUrl = this.history.pop();
      if (lastUrl.includes('survey-id') || lastUrl.includes('not-found') || lastUrl.includes('iframe') || lastUrl.includes('send-update-route')){
        this.history = [];
        this.router.navigateByUrl('/home');
        return;
      }
      this.router.navigateByUrl(lastUrl)
    } else {
      this.router.navigateByUrl('/home')
    }
  }

}